import React from "react";
import FormSubmissionTable, { ColumnHeader } from "../formSubmissionsDataGrid";

const ContactUsFormSubmission: React.FC = () => {
  const columnHeaders: ColumnHeader[] = [
    {
      Column_Name: "Submission ID",
      Field_Name: "Submission_ID",
    },
    {
      Column_Name: "User Email",
      Field_Name: "User_Email",
    },
    {
      Column_Name: "Entry Date",
      Field_Name: "Entry_Date",
    },
  ];

  return <FormSubmissionTable columnHeaders={columnHeaders} formId={6} formName={"Contact Us"}></FormSubmissionTable>;
};

export default ContactUsFormSubmission;
